import { useMemo } from "react";
import { Button, ButtonSize, ButtonVariant, Show } from "shared/components";
import { cx } from "shared/utils";

import { Section } from "views/applications-id-report/components/Section";
import { CombinedIncome } from "../types/income";
import { mapIncomeSourceStatus, scrollToIncomeSource } from "../helpers";
import { HugeiconsIcon } from "@hugeicons/react";
import { AlertCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { IncomeType } from "shared/types";

interface DocumentWarningsProps {
  incomes: CombinedIncome[];
}

export const DocumentWarnings = ({ incomes }: DocumentWarningsProps) => {
  const incomeSourceWarnings = useMemo(
    () =>
      incomes
        .map((inc) => mapIncomeSourceStatus(inc))
        .filter(
          (incSource) =>
            incSource.status &&
            incSource.status !== "Accepted" &&
            incSource.type !== IncomeType.HousingAssistance
        ),
    [incomes]
  );

  if (incomeSourceWarnings.length === 0) return null;

  return (
    <Section sectionTitle="Warnings" maxWidth="none">
      <div className="flex flex-col gap-4">
        {incomeSourceWarnings.map(
          ({ status, incomeName, incomeId, description }) => {
            return (
              <div
                key={incomeId}
                className="flex w-full justify-between flex-wrap md:flex-nowrap gap-y-2 items-start"
              >
                <div className="flex items-center gap-3">
                  <HugeiconsIcon
                    icon={AlertCircleIcon}
                    size={20}
                    className={cx(
                      status === "Rejected" && "text-danger-500",
                      status === "Warning" && "text-warning-500"
                    )}
                  />
                  <div className="flex flex-col gap-1 items-start">
                    <p className="text-content-1000 font-medium">
                      Income source &ldquo;
                      <span className="font-bold">{incomeName}</span>
                      &rdquo;
                      <Show if={status === "Rejected"}>
                        {` could not be verified`}
                      </Show>
                      <Show if={status === "Warning"}>
                        {` has verification warnings`}
                      </Show>
                    </p>
                    <p className="text-content-400 font-normal text-sm">
                      {description}
                    </p>
                  </div>
                </div>

                <Button
                  variant={ButtonVariant.BASE}
                  size={ButtonSize.SM}
                  onClick={() => scrollToIncomeSource(incomeId)}
                >
                  Review
                </Button>
              </div>
            );
          }
        )}
      </div>
    </Section>
  );
};
